import React from 'react';
import DeviationDuperbrowseContext from '../../../../Duperbrowse/DeviationDuperbrowseContext';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
import StandardThumb from '../../../../DeviationViews/Thumb/Standard';
import MobileThumb from '../../../../DeviationViews/Thumb/Mobile';
import { useMeasureElementCookie } from '@wix/da-hooks/pkg/useMeasureElement/useMeasureElementCookie';
import s from './DeviationMobileList.scss';
/** Sidebar block layout id 5 */ const DeviationMobileList = ({ block, deviation: parentDeviation })=>{
    var _block_deviations;
    const isMLT = block.contentType === 'recommended';
    const deviations = (_block_deviations = block.deviations) === null || _block_deviations === void 0 ? void 0 : _block_deviations.slice(0, 9);
    const { ref, dimensions: measuredContainer } = useMeasureElementCookie(MeasuredCookieType.DEVIATION_SIDEBAR, {
        cookieDim: 'width'
    });
    return /*#__PURE__*/ React.createElement(SidebarBlockWrapper, {
        deviation: parentDeviation,
        block: block
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(DeviationDuperbrowseContext, {
        streamId: `sidebar-mobilelist-${block.contentType}`,
        deviations: deviations !== null && deviations !== void 0 ? deviations : [],
        parent: {
            typeId: getDeviationResourceType(parentDeviation),
            itemId: parentDeviation.deviationId
        }
    }, /*#__PURE__*/ React.createElement("div", {
        ref: ref
    }, deviations === null || deviations === void 0 ? void 0 : deviations.map((deviation)=>isMLT ? /*#__PURE__*/ React.createElement(MobileThumb, {
            key: deviation.deviationId,
            className: s['thumb'],
            deviation: deviation,
            width: measuredContainer.width,
            // heads-up: this includes the controls above and below the image
            height: 400
        }) : /*#__PURE__*/ React.createElement(StandardThumb, {
            key: deviation.deviationId,
            deviation: deviation,
            width: measuredContainer.width,
            height: 239,
            className: s['thumb']
        }))))));
};
DeviationMobileList.displayName = 'DeviationMobileList';
export default DeviationMobileList;
